interface TimeProps {
  days?: number;
  hours?: number;
  minutes?: number;
  seconds?: number;
}

const ONE_SECOND = 1000;

const ONE_MINUTE = ONE_SECOND * 60;

const ONE_HOUR = ONE_MINUTE * 60;

const ONE_DAY = ONE_HOUR * 24;

const toTimestamp = (date: Date) => date.getTime();

const toDate = (timestamp: number) => new Date(timestamp);

const addTime = (timestamp: number, time?: TimeProps) => {
  if (!time) return timestamp;

  const { days = 0, hours = 0, minutes = 0, seconds = 0 } = time;

  const newDate = new Date(timestamp);

  newDate.setDate(newDate.getDate() + days);
  newDate.setHours(newDate.getHours() + hours);
  newDate.setMinutes(newDate.getMinutes() + minutes);
  newDate.setSeconds(newDate.getSeconds() + seconds);

  return toTimestamp(newDate);
};

const subtractTime = (timestamp: number, time?: TimeProps) => {
  if (!time) return timestamp;

  const { days = 0, hours = 0, minutes = 0, seconds = 0 } = time;

  const newDate = new Date(timestamp);

  newDate.setDate(newDate.getDate() - days);
  newDate.setHours(newDate.getHours() - hours);
  newDate.setMinutes(newDate.getMinutes() - minutes);
  newDate.setSeconds(newDate.getSeconds() - seconds);

  return toTimestamp(newDate);
};

const getDiff = (newerTimestamp: number, olderTimestamp: number) => {
  const diff = newerTimestamp - olderTimestamp;
  return diff;
};

export {
  toTimestamp,
  toDate,
  addTime,
  getDiff,
  subtractTime,
  ONE_SECOND,
  ONE_MINUTE,
  ONE_HOUR,
  ONE_DAY,
};
